"use client";

import { useEffect, useState } from "react";
import { LuX } from "react-icons/lu";
import Image from "next/image";

const DISMISS_KEY = "hopp_smart_banner_dismissed";
const DISMISS_DURATION_MS = 30 * 60 * 1000; // 30 minutes

function isAndroid(): boolean {
  if (typeof navigator === "undefined") return false;
  return /android/i.test(navigator.userAgent);
}

function isDismissed(): boolean {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) return false;
    const dismissedAt = Number(raw);
    if (Number.isNaN(dismissedAt)) return false;
    return Date.now() - dismissedAt < DISMISS_DURATION_MS;
  } catch {
    return false;
  }
}

export function SmartAppBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isAndroid() && !isDismissed()) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- client-only UA/localStorage check; must run post-hydration
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleDismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch {
      // localStorage may be unavailable in some contexts
    }
  };

  return (
    <div
      className="sticky top-0 z-[9999] flex items-center gap-3 border-b border-white/10 bg-[#0b0c0f] px-3 py-2.5 shadow-lg"
      role="banner"
      aria-label="Download HOPP app"
    >
      <button
        type="button"
        onClick={handleDismiss}
        className="flex shrink-0 items-center justify-center rounded-full p-1 text-white/50 transition-colors hover:bg-white/10 hover:text-white"
        aria-label="Dismiss app banner"
      >
        <LuX size={18} />
      </button>

      <Image
        src="/apple-touch-icon.png"
        alt="HOPP app icon"
        width={40}
        height={40}
        className="shrink-0 rounded-lg"
      />

      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold leading-tight text-white">HOPP</p>
        <p className="text-xs leading-tight text-white/60">Android App</p>
      </div>

      <span
        className="shrink-0 rounded-full bg-white/10 px-4 py-1.5 text-sm font-semibold text-white/40 cursor-default"
      >
        Coming Soon
      </span>
    </div>
  );
}
